import React, { Component } from 'react';
import { object } from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Breadcrumbs } from '@fiverr-private/fit';
import {
    buildCategoryNameKey,
    buildNestedSubCategoryNameKey,
    buildSubCategoryNameKey
} from '../../../utils/translation/categories';
import {
    MP_CLICKED_BREADCRUMBS_PRO,
    MP_CLICKED_BREADCRUMBS_CATEGORY,
    MP_CLICKED_BREADCRUMBS_SUBCATEGORY,
    MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY
} from '../../../utils/mixPanelEvents';
import {
    getCategoryUrl,
    getSubCategoryUrl,
    getNestedSubCategoryUrl,
    getProUrl
} from '../../../utils/routes';

import './style.scss';

class CategoriesTreeBreadcrumbs extends Component {

    reportClickEvent(eventName) {
        const { biEvents, general } = this.context;
        const params = _.pick(general, [
            'categoryId', 'subCategoryId', 'nestedSubCategoryId', 'isPro'
        ]);
        biEvents.sendMixPanelEvent({
            eventName,
            params
        });
    }

    get categoryUrl() {
        const { general, pathfinderWrapper } = this.context;
        const { isPro, categorySlug } = general;

        return getCategoryUrl({ categorySlug, isPro, pathfinderWrapper });
    }

    get subCategoryUrl() {
        const { general, pathfinderWrapper } = this.context;
        const { categorySlug, subCategorySlug, isPro } = general;

        return getSubCategoryUrl({ categorySlug, subCategorySlug, isPro, pathfinderWrapper });
    }

    get nestedSubCategoryUrl() {
        const { general, pathfinderWrapper } = this.context;
        const { categorySlug, subCategorySlug, nestedSubCategorySlug } = general;

        return getNestedSubCategoryUrl({ categorySlug, subCategorySlug, nestedSubCategorySlug, pathfinderWrapper });
    }

    render() {
        const { general, pathfinderWrapper } = this.context;
        const {
            categoryId,
            subCategoryId,
            nestedSubCategoryId,
            categorySlug,
            subCategorySlug,
            nestedSubCategorySlug,
            isPro
        } = general;

        if (!(categoryId && subCategoryId)) {
            return null;
        }

        const showCategory = !!(categoryId && categorySlug);
        const showSubCategory = !!(showCategory && subCategoryId && subCategorySlug);
        const showNestedSubCategory = !!(showSubCategory && nestedSubCategoryId && nestedSubCategorySlug);

        const classes = isPro ? classNames('pro-breadcrumbs', 'categories-breadcrumbs') :
            classNames('categories-breadcrumbs');

        return (
            <Breadcrumbs className={classes}>
                {isPro &&
                <Breadcrumbs.Crumb className="category-breadcrumbs">
                    <a href={getProUrl({ pathfinderWrapper })}
                        onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_PRO)}>
                        <I18n k="gig_page_perseus.general.fiverr_pro"/>
                    </a>
                </Breadcrumbs.Crumb>
                }
                {showCategory &&
                <Breadcrumbs.Crumb className="category-breadcrumbs">
                    <a href={this.categoryUrl}
                        onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_CATEGORY)}>
                        <I18n k={buildCategoryNameKey(categoryId)}/>
                    </a>
                </Breadcrumbs.Crumb>
                }
                {showSubCategory &&
                <Breadcrumbs.Crumb className="category-breadcrumbs">
                    <a href={this.subCategoryUrl}
                        onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_SUBCATEGORY)}>
                        <I18n k={buildSubCategoryNameKey(subCategoryId)}/>
                    </a>
                </Breadcrumbs.Crumb>
                }
                {showNestedSubCategory &&
                <Breadcrumbs.Crumb className="category-breadcrumbs">
                    <a href={this.nestedSubCategoryUrl}
                        onClick={() => this.reportClickEvent(MP_CLICKED_BREADCRUMBS_NESTED_SUBCATEGORY)}>
                        <I18n k={buildNestedSubCategoryNameKey(subCategoryId, nestedSubCategoryId)}/>
                    </a>
                </Breadcrumbs.Crumb>
                }
            </Breadcrumbs>
        );
    }
}

CategoriesTreeBreadcrumbs.contextTypes = {
    general: object,
    pathfinderWrapper: object,
    biEvents: object
};

export default CategoriesTreeBreadcrumbs;
